// extracted by mini-css-extract-plugin
export default {"wrapper":"ZyTGw","text":"ikx6q","options__group":"UQyjh"};